module.exports = __webpack_public_path__ + "static/media/BS_O_Embroidery_Bicocca_DKGrey_White.2980c3b5.png";